// extracted by mini-css-extract-plugin
module.exports = {"delta-pro-ultra-A":"A_delta-pro-ultra-A__qrqnK"};